Auth = require 'db/auth'
ModelCache = require 'db/model-cache'

module.exports = (url) ->
  if url.indexOf('/') != 0 && url.indexOf(siteDomain + '/') != 0
    return false

  url = url
    .replace(/// ^ #{ siteDomain } ///, '')
    .replace(/// ^ /(?=.) ///, '')

  # Drop the query or hash; those don't factor into whether a page is a
  # web client page or not
  url = url.replace(/// [\?\#].* $///, '')

  if /// \.[a-z]+ $///i.test(url)
    # client never handles any pages with extensions; probably an export
    return false

  if ///^ ([bce]|board|card|org) / ///.test(url)
    # client serves board and card pages
    return true

  if ///^ search (/|$) ///.test(url)
    # client serves any searches
    return true

  if Auth.isLoggedIn()
    if /// ^ #{ Auth.myUsername() } (/|$) ///.test(url)
      # client serves member pages
      return true
    if url == '/'
      # client serves the logged-in landing page (the boards page)
      return true

  if /// ^ shortcuts /? $ ///.test(url)
    return true

  # It might still be /username or /orgname ... or it might be a new
  # meta page like /awesome
  #
  # There's really no way to know, so check and see if we know about any
  # members or clients that have names matching the current route

  if (possibleName = /// ^ [^/\?\#]+ ///.exec(url)?[0])?
    # Handle aliases; it's unlikely that we'd actually have any links to these
    # but let's handle them just in case
    if Auth.isLoggedIn() && possibleName in ['me', 'my', 'you', 'your', 'username']
      return true

    if /^[a-z0-9_]{3,}$/.test(possibleName)
      if ModelCache.findOne('Member', 'username', possibleName)?
        return true
      if ModelCache.findOne('Organization', 'name', possibleName)?
        return true

  false



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/is-web-client-page.coffee